import React from "react";
import { Helmet } from "react-helmet";
import Foto1 from "../img/Cristo-que-vigila-el-pueblo-Cerro-Verde-y-la-planta-de-bombeo-de-la-minera.jpg";
import Foto2 from "../img/Roxana-Ortiz.jpg";
import Foto3 from "../img/Acta-monitoreo.jpeg";
import Foto4 from "../img/Centro-de-Salud-ya-no-monitorea-el-aire.jpg";
import Foto5 from "../img/monitores-apagados.jpg";
import Foto6 from "../img/planta-de-tratamiento-al-fondo-los-relaves.jpg";
import Foto7 from "../img/CERRO-VERDE-AEREA.jpg";
import Foto8 from "../img/CERRO-VERDE-AEREA-2.jpg";
import Foto9 from "../img/vertiente-de-agua.jpg";
import Foto10 from "../img/vertiente-de-agua-2.jpg";
import Foto11 from "../img/cuadro-1-analisis.png";
import Foto12 from "../img/cuadro-2-analisis.png";
import Foto13 from "../img/luz-guerra-1.jpg";

import Fondo from "../img/Dibujo-4-Cerro-Verde.jpg";
import SocialShare from "../components/SocialShare";
import { Fade } from "react-awesome-reveal";
import Author from "../img/mabel.jpeg";
import Footer from "../components/Footer";
//import Navbar from "../components/Navbar";

const NotaArequipa = () => {
  return (
    <>
      <div className="nota">
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Cerro Verde y las deficiencias en sus monitoreos participativos
          </title>
          <meta
            property="og:title"
            content="Cerro Verde y las deficiencias en sus monitoreos participativos"
          />
          <meta
            name="description"
            content="De un total de 3115 firmas de las actas de monitoreo ambiental participativo efectuados por Cerro Verde entre los años 2013 y 2019, solo el 18% corresponde a ciudadanos de los distritos con potencial impacto de la actividad minera"
          ></meta>
          <meta
            property="og:url"
            content={
              process.env.REACT_APP_URL +
              "/cerro-verde-deficiencias-monitoreos-participativos"
            }
          />
          <meta property="og:image" content={"https://fundacionmohme.org"+Fondo} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image:src" content={"https://fundacionmohme.org"+Fondo} />
        </Helmet>
        <div>
          <header className="">
            <div className="header-bg">
              <img
                className="img-fluid"
                src={Fondo}
                alt="Cerro Verde y las deficiencias en sus monitoreos participativos"
              />
            </div>
            <div className="nota-header-content  ">
              <div className="container d-flex justify-content-center flex-column">
                <Fade delay={80} triggerOnce>
                  <h1>
                    Cerro Verde y las deficiencias en sus monitoreos
                    participativos
                  </h1>
                  <SocialShare
                    url={
                      process.env.REACT_APP_URL +
                      "/cerro-verde-deficiencias-monitoreos-participativos"
                    }
                    text="Cerro Verde y las deficiencias en sus monitoreos participativos"
                  />
                  <p className="bajada d-none d-lg-block d-md-none">
                    Los monitoreos participativos son la única vía para que la
                    población pueda intervenir en la vigilancia ambiental de las
                    operaciones mineras, pero la Sociedad Minera Cerro Verde
                    lleva a cabo estos procesos de manera reservada e irregular.
                    Así, de un total de 3115 firmas de las actas de monitoreo
                    ambiental participativo efectuados por Cerro Verde entre los
                    años 2013 y 2019, solo el 18% corresponde a ciudadanos de
                    los distritos con potencial impacto de la actividad minera
                  </p>
                </Fade>
              </div>
            </div>
          </header>
        </div>
        <main>
          <div className="container">
            <Fade delay={80}>
              <p className="bajada d-none d-block d-lg-none">
                Los monitoreos participativos son la única vía para que la
                población pueda intervenir en la vigilancia ambiental de las
                operaciones mineras, pero la Sociedad Minera Cerro Verde lleva a
                cabo estos procesos de manera reservada e irregular. Así, de un
                total de 3115 firmas de las actas de monitoreo ambiental
                participativo efectuados por Cerro Verde entre los años 2013 y
                2019, solo el 18% corresponde a ciudadanos de los distritos con
                potencial impacto de la actividad minera
              </p>
            </Fade>
          </div>
          <div className="container">
            <Fade delay={80}>
              <div className="author d-flex">
                <div className="circle">
                  <img src={Author} className="img-fluid" alt="Mabel Cáceres" />
                </div>
                Por Mabel Cáceres y Josué del Mar – El Búho
              </div>
            </Fade>

            <Fade delay={80}>
              <p>
                <span className="capital-letter">L</span>uz Guerra es una vecina
                del poblado de Cerro Verde, el más cercano a las operaciones
                mineras, que ha decidido sostener su particular batalla para
                demostrar todos los perjuicios que ella cree ha traído la minera
                a su comunidad. Desde el ruido, el mal olor y el color del agua
                que arroja al río la empresa que ha instalado una gigantesca
                bomba de agua a pocos metros de su casa; hasta la permanente
                vibración de esa bomba que ha partido en dos la vivienda de un
                piso que habita desde siempre.
              </p>

              <p>
                Ella, su familia y sus vecinos, nunca habían visto, en su
                estrecha pista, maquinarias de ruedas tan grandes y camiones de
                gran tonelaje; que son parte de los 6 mil millones de dólares
                que la empresa minera ha invertido desde 2013 para cuadriplicar
                su producción de cobre, hasta convertirse en la más grande del
                Perú y la tercera en el mundo. Cerro Verde extrae diariamente
                410 mil toneladas métricas de cobre, un volumen similar a una
                manzana entera de casas de cuatro pisos cada una.
              </p>
              <p>
                Pero no es la maquinaria lo que más les incomoda, ni la bomba
                cuya vibración ha cuarteado la mayoría de casas cercanas, ni el
                olor nauseabundo que despide la planta de tratamiento de aguas
                servidas, también muy cerca de la población; sino lo que
                advierte como un deficiente control y fiscalización ambiental
                por parte del estado.
              </p>
              <p>
                Parte de esa desconfianza nace de los llamados monitoreos
                ambientales participativos; a los que, asegura, la población
                nunca ha sido convocada de manera abierta y transparente. Como
                muchos otros vecinos con los que{" "}
                <a
                  href="https://elbuho.pe/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  El Búho
                </a>{" "}
                pudo dialogar las últimas semanas, Luz Guerra acusa un manejo
                oscuro de esta vigilancia participativa.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto1}
                  alt="Pueblo joven Cerro Verde, se opuso en su momento a la construcción de la planta de tratamiento La Enlozada, muy cerca del lugar, cuya operación afectó a decenas de viviendas. Foto: Erick Rodríguez."
                />
                <div className="img-legend">
                  Pueblo joven Cerro Verde, se opuso en su momento a la
                  construcción de la planta de tratamiento La Enlozada, muy
                  cerca del lugar, cuya operación afectó a decenas de viviendas.
                  Foto: Erick Rodríguez.
                </div>
              </div>

              <h2>¿Quiénes participan?</h2>
              <p>
                <a
                  href="https://elbuho.pe/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  El Búho
                </a>{" "}
                accedió a las actas de los monitoreos participativos efectuados
                por Cerro Verde entre 2013 y 2019. Una verificación de las
                identidades de las 3115 firmas en estos documentos, arroja un
                resultado que pone en entredicho la transparencia de estos
                procesos. En buena cuenta, la asistencia de los potenciales
                afectados es minoritaria y los resultados no se difunden de
                manera masiva.
              </p>

              <p>
                Los monitoreos participativos ambientales son una obligación de
                las empresas con actividades extractivas, a la que se
                comprometen como parte de su programa de vigilancia ambiental,
                cuando solicitan autorización para operar. El plan está
                contemplado en el Estudio de Impacto Ambiental y establece la
                frecuencia y tipo de monitoreo que realizará de manera
                participativa. La finalidad es asegurarse que sus operaciones no
                impactan negativamente en el entorno.
              </p>
              <p>
                Según la norma “el Programa de Monitoreo Ambiental comprenderá
                actividades que permitan efectuar un seguimiento representativo
                y oportuno del desempeño ambiental, y generar información que
                permita evaluar las condiciones del ambiente que esté
                influenciado por las operaciones mineras o los que tengan
                potencial de ser afectados por éstas, así como por las
                actividades que se desarrollen en torno a aquellas”.
              </p>
              <p>
                Pese al reclamo de dirigentes de los pueblos impactados por las
                operaciones mineras, estos monitoreos se llevan a cabo en
                presencia de personas, en su mayoría, ajenas a la población que
                habita esos lugares: estudiantes universitarios, funcionarios de
                la minera y de las empresas encargadas del estudio.
              </p>

              <p>
                “Nunca se ha hecho una convocatoria pública”, sostiene Roxana
                Ortiz, otra vecina de Cerro Verde, también afectada por las
                vibraciones de la planta de bombeo que no ha obtenido reparación
                para los daños estructurales causados en su vivienda. En una
                ocasión, ella y Luz Guerra descubrieron casualmente que se
                realizaría un monitoreo de aire en su zona y exigieron
                participar. Tomaron fotografías de los filtros de la estación de
                monitoreo, pero nunca fueron informadas de los resultados y
                medidas a tomarse.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto2}
                  alt="Roxana Ortiz, nació y vive en Cerro Verde. Tiene su casa cuarteada en la manzana A, Lt 25, pide claridad sobre los monitoreos de agua y aire."
                />
                <div className="img-legend">
                  Roxana Ortiz, nació y vive en Cerro Verde. Tiene su casa
                  cuarteada en la manzana A, Lt 25, pide claridad sobre los
                  monitoreos de agua y aire. Foto: Erick Rodríguez.
                </div>
              </div>
              <h2>Las actas hablan</h2>
              <p>
                En promedio, solo una de cada cinco firmas en las actas de
                monitoreo participativo corresponde a alguien que se identifica
                como vecino de la zona. Hay casos en que no asiste ningún
                poblador de los distritos afectados; o un vecino que asiste a
                monitoreos en más de un distrito. Según algunas actas, los
                únicos presentes son funcionarios de la minera y representantes
                de los laboratorios y consultoras.
              </p>
              <div className="img-container-doc">
                <img
                  className="img-fluid full-width"
                  src={Foto3}
                  alt="Una de las 162 actas de monitoreo ambiental que lleva a cabo SMCV y que figuran en los informes remitidos a OEFA"
                />
                <div className="img-legend">
                  Una de las 162 actas de monitoreo ambiental que lleva a cabo
                  SMCV y que figuran en los informes remitidos a OEFA. En esta
                  ocasión, ningún representante de la población estuvo presente.
                </div>
              </div>
              <p>
                “Solo convocan a sus allegados. Una vez quisimos participar y
                fuimos hasta donde iba a realizarse el monitoreo en Yarabamba,
                pero la minera y el municipio, avisados, decidieron postergar la
                actividad”. Así se expresa Jesús Aguilar, miembro del Frente de
                Defensa que han formado representantes de los distritos de
                Uchumayo, Tiabaya, Quequeña, Yarabamba, Characato y Hunter; los
                más cercanos al centro de operaciones. Su finalidad es reclamar
                sobre éste y otros aspectos relacionados con los efectos de la
                minería en la ciudad de Arequipa.
              </p>
              <p>
                Según el informe del Organismo de Evaluación y Fiscalización
                Ambiental (OEFA), entre los años 2013 y 2019 se realizaron 85
                informes de monitoreo participativo por parte de Sociedad Minera
                Cerro Verde en los distritos vecinos de Uchumayo, Socabaya,
                Sachaca, Yarabamba y Quequeña.
              </p>
              <p>
                Como muestra el gráfico, del total de firmantes (3115), solo el
                18% representan a pobladores o delegados de asociaciones que
                residen en los distritos comprometidos. Aun así, algunos de los
                firmantes rubrican actas de otros distritos, a los que no
                representan y existen actas sin presencia de pobladores.
              </p>
              <h2>
                Procedencia de participantes en monitoreos ambientales
                participativos
              </h2>
              <div className="container-chart">
                <iframe
                  className="iframeAqp"
                  title="Procedencia de participantes en monitoreos ambientales participativos"
                  aria-label="chart"
                  id="datawrapper-chart-4VjV6"
                  src="https://datawrapper.dwcdn.net/4VjV6/5/"
                  scrolling="no"
                  frameborder="0"
                  style={{
                    width: "100%",
                    minWidth: "100% !important",
                    border: "none",
                  }}
                  height="494"
                ></iframe>
              </div>
              <p>
                El grupo más numeroso de asistentes (33%) corresponde a
                estudiantes universitarios que no se identifican como pobladores
                de estos distritos. Se trata de alumnos de carreras como
                ingeniería ambiental, ingeniería química o ingeniería
                industrial; quienes son enviados por sus docentes a invitación
                de Cerro Verde, como parte de una experiencia formativa.
              </p>

              <p>
                Le sigue el grupo de representantes y autoridades de
                municipalidades, que aglutinan un 12%.
              </p>

              <p>
                Del cuarto al sexto grupo son personas relacionadas con la
                empresa minera, lo que incluye a los representantes de
                laboratorios y consultoras que toman parte del proceso,
                contratadas por Cerro Verde. Por separado son el 11%, 4,6% y 8%;
                pero en conjunto, conglomeran el 23,6% del total de firmas, lo
                que los convierte en el segundo grupo de firmantes más numeroso.
              </p>
              <p>
                Con menor participación figuran representantes del Colegio de
                Ingenieros del Perú, sede Arequipa, el Instituto de Gestión
                Ambiental (ICIGA) de la Universidad Nacional San Agustín y
                representantes del Estado (subprefectos y gobernaturas). En la
                cola se encuentra la representación de OEFA, que solo aparece en
                la firma de 10 de las 162 actas revisadas.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto4}
                  alt="La estación de monitoreo de aire"
                />
                <div className="img-legend">
                  <strong>Sábado 26 de setiembre</strong>. La estación de
                  monitoreo de aire, al lado del Centro de Salud del PP.JJ.
                  Cerro Verde ha sido retirada del lugar y no funciona desde el
                  inicio de la pandemia.
                </div>
              </div>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto5}
                  alt="La estación de monitoreo de extracción de agua del río Chili"
                />
                <div className="img-legend">
                  <strong>Sábado 26 de setiembre</strong>. La estación de
                  monitoreo de extracción de agua del río Chili, colocada para
                  la vigilancia de la población de Cerro Verde, está inoperativa
                  hace meses, según los vecinos.
                </div>
              </div>
              <h2>Testimonio de parte</h2>
              <p>
                Entre los nombres más recurrentes en las actas de monitoreos
                está el de la ingeniera ambiental Alexandra Sánchez Moreno,
                egresada de la Universidad Católica Santa María. De acuerdo con
                la documentación presentada por Cerro Verde, la joven participó
                en varios monitoreos del año 2017. Su firma aparece estampada
                hasta en 11 actas de los distritos de Uchumayo, Hunter y
                Tiabaya.
              </p>
              <p>
                Consultada por{" "}
                <a
                  href="https://elbuho.pe/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  El Búho
                </a>{" "}
                sobre su participación, la estudiante explicó que fue parte de
                un programa promovido por la Escuela Profesional de Ingeniería
                Ambiental. En función a un convenio, se daba oportunidad a
                estudiantes con buenas calificaciones a participar en los
                talleres de inducción y tomar parte en el recojo de muestras. En
                años posteriores se amplió la convocatoria a todo el cuerpo
                estudiantil, según detalló.
              </p>
              <p>
                “Ahora es de acceso libre. La semana antes del monitoreo se
                publicita. Dentro de la misma universidad pueden participar las
                personas que deseen saber cómo se hacen los monitoreos y conocer
                los resultados”, explica. La ingeniera ambiental indicó que
                dividen a los alumnos interesados en grupos para participar en
                días diferentes en varios puntos. Sobre los resultados, sin
                embargo, dijo desconocerlos.
              </p>
              <p>
                Otra estudiante, de la misma universidad, María Alejandra
                García, participó en un monitoreo ambiental del año 2013, cuando
                estaba en el primer año de su carrera de Ingeniería Ambiental.
                Según dijo, fue su profesor quien la convocó por sus buenas
                notas. En su caso, la jornada solo duró un día, desde las 7 de
                la mañana. Les dieron una charla y luego los llevaron a 5 puntos
                de monitoreo; después de un refrigerio la devolvieron a su casa.
                Nunca más supo de los resultados y tampoco la volvieron a
                invitar a lo largo de 5 años de su carrera.
              </p>
              <p>
                Roxana Ortiz protesta: “esos monitoreos son un chiste, la gente
                que va no entiende ni siquiera que es un PM10. Yo tomé fotos del
                filtro de aire que salía negro; pero después, según ellos, todo
                está bien; no sabemos qué harán con eso”. Luz Guerra dice, a su
                vez, que la minera publica las fotos y las actividades de
                monitoreo en las revistas que distribuyen entre los vecinos,
                “pero todo a su favor”.
              </p>
              <div className="img-container">
                <img
                  className="img-fluid"
                  src={Foto6}
                  alt="Planta de tratamiento de aguas servidas La Enlozada"
                />
                <div className="img-legend">
                  Planta de tratamiento de aguas servidas La Enlozada. Al fondo,
                  de color claro, la presa de relaves de la minera y más allá el
                  tajo de la explotación. Foto: Erick Rodríguez
                </div>
              </div>
              <div className="img-container">
                <img
                  className="img-fluid"
                  src={Foto7}
                  alt="Vista satelital del asiento minero"
                />
                <div className="img-legend">
                  Vista satelital del asiento minero. En color verde, la poza de
                  relaves. Nótese la cercanía a la población de Cerro Verde.
                  Captura: Google Earth.
                </div>
              </div>
              <div className="img-container">
                <img
                  className="img-fluid"
                  src={Foto8}
                  alt="Vista satelital donde puede apreciarse la distancia relativa entre el tajo de explotación"
                />
                <div className="img-legend">
                  Vista satelital donde puede apreciarse la distancia relativa
                  entre el tajo de explotación, la poza de relaves, la localidad
                  de Cerro Verde y los distritos aledaños. Captura: Google Earth
                </div>
              </div>
              <h2>Vacíos sobre la participación</h2>
              <p>
                Si bien el monitoreo ambiental participativo es una obligación
                incluida en el Plan de Vigilancia Ambiental de las industrias
                extractivas, no hay norma que vigile su cumplimiento en
                frecuencia y en calidad de participación.
              </p>
              <p>
                El Reglamento de Protección y Gestión ambiental señala en su
                artículo 18, señala que el titular minero está obligado a: b) El
                monitoreo y control permanente de sus operaciones para verificar
                el cumplimiento de las obligaciones y compromisos a su cargo,
                así como, la calidad ambiental en aquellas áreas y con la
                frecuencia definida en el instrumento de gestión ambiental
                correspondiente. Los registros de monitoreo deben conservarse
                por un periodo de cinco (5) años, los mismos que deberán ser
                remitidos al Organismo de Evaluación y Fiscalización Ambiental
                (OEFA) y estar a disposición de las autoridades competentes en
                caso lo soliciten.».
              </p>
              <p>
                Consultado el Organismo de Evaluación y Fiscalización Ambiental,
                señala que no es competencia de la OEFA participar en el diseño
                y/o evaluación de estos monitoreos. Existe un Reglamento de
                Participación en los Monitoreos Ambientales a cargo de OEFA,
                pero el texto no señala nada sobre los monitoreos participativos
                que están a cargo de la propia empresa extractiva.
              </p>
              <p>
                Entonces la pregunta es: ¿quiénes deberían participar en un
                monitoreo ambiental? La respuesta lógica parece ser que deben
                participar las personas o entidades directamente interesadas en
                la evaluación de la calidad del agua, del aire y del suelo del
                entorno; es decir, los habitantes de las zonas impactadas por la
                actividad extractiva.
              </p>
              <p>
                El monitoreo, en general, contempla una etapa previa de
                inducción, un taller para planificar, la actividad misma y un
                taller para exponer y evaluar los resultados. En el caso de
                Cerro Verde, los participantes señalan que si bien hay una
                jornada de inducción para explicar las fases y características
                del monitoreo, no hay una jornada posterior para explicar u
                socializar los resultados de la evaluación que la realiza una
                empresa privada, contratada por la empresa minera.
              </p>
              <p>
                No son pocos los reclamos que, en este aspecto, han surgido en
                la sociedad arequipeña. En 2019, la Federación de Trabajadores
                de Arequipa (FDTA) anunció que denunciará a la minera por
                contaminar siete distritos. El sustento son las denuncias
                presentadas por pobladores ante OEFA y las sanciones impuestas
                por esta entidad. Pero en ninguna parte hacen alusión a los
                resultados del monitoreo participativo.
              </p>
              <div className="img-container">
                <img
                  className="img-fluid"
                  src={Foto9}
                  alt="Desfogue de aguas excedentes de La Enlozada en el Río Chili"
                />
              </div>
              <div className="img-container">
                <img
                  className="img-fluid"
                  src={Foto10}
                  alt="Desfogue de aguas excedentes de La Enlozada en el Río Chili"
                />
                <div className="img-legend">
                  <strong>Sábado 26 de setiembre</strong>. Desfogue de aguas
                  excedentes de La Enlozada en el Río Chili. El color marrón
                  turbio es característico en las aguas que provienen de la
                  minera, señalan los vecinos y piden un monitoreo más frecuente
                  y transparente.
                </div>
              </div>
              <p>
                Según el Estudio Sombra de la Transparencia de la Información
                Socioambiental en Perú, realizado por el Grupo Propuesta
                Ciudadana y DAR, “una de las mayores demandas de sociedad civil,
                pueblos indígenas y poblaciones locales es la difusión de
                información socioambiental de los proyectos extractivos; y la
                principal razón es la conflictividad social por falta de
                información sobre los impactos socioambientales de los
                proyectos; estudios de impacto ambiental, y procesos de
                fiscalización ambiental”.
              </p>
              <p>
                Luz Guerra personifica esa explicación. La falta de información
                ha incidido en su determinación, junto con otros ciudadanos de
                su entorno, de participar en movilizaciones y protestas;
                reclaman respeto de parte de la minera, y claridad respecto al
                impacto en el suelo y el agua. “Nunca más la vida ha sido igual
                aquí en Cerro Verde, cada vez estamos peor”, se queja.
              </p>
              <h2>Compromisos no honrados</h2>
              <p>
                Pese a estos vacíos, lo concreto es que, en el Estudio de
                Impacto Ambiental para la ampliación de operaciones de Sociedad
                Minera Cerro Verde, se establecía una frecuencia, lugares y tipo
                de monitoreos, que debían ser participativos. El compromiso no
                ha sido cumplido por la empresa. Así, de las actas remitidas por
                OEFA, se tiene un número de monitoreos sistemáticamente menor al
                que se había planteado:
              </p>
              <div className="img-container-2">
                <img className="img-fluid" src={Foto11} alt="Aire" />
                <div className="img-legend">
                  <strong>AIRE</strong>. Como puede verse, la frecuencia de
                  monitoreo participativo solo se ha cumplido para los gases
                  NO2, SO2 y CO (semestral), no así para la presencia de
                  material particulado PM10 y PM 2.5 que debió hacerse cada tres
                  meses y la presencia de Plomo (Pb) y arsénico (As) de forma
                  mensual.
                </div>
              </div>
              <div className="img-container-2">
                <img className="img-fluid" src={Foto12} alt="AGUA" />
                <div className="img-legend">
                  <strong>AGUA</strong>: Los cumplimientos están marcados con
                  una (x), respecto al compromiso realizado por la propia SMCV
                  en su EIA
                </div>
              </div>

              <p>
                Además, los resultados de estos monitoreos han venido arrojando,
                de manera recurrente, medidas por encima de los valores
                permitidos ambientalmente para considerarlos inocuos; pero no se
                ha tomado ninguna medida al respeto. La OEFA no actúa ante estas
                evidencias. En estos 7 años, solo ha realizado 5 monitoreos y
                siempre ha encontrado incumplimientos. No obstante, el monitoreo
                participativo no ha sido objeto de ninguna medida de control.
              </p>
              <p>
                Según el especialista ambiental Hernando Núñez del Prado, “estos
                procesos se han convertido en mero trámite, donde se trata de
                mostrar la participación de algunos pobladores de distritos
                considerados en el Área de Influencia Directa (AID). También se
                invita a estudiantes de carreras de Ingeniería Ambiental de las
                universidades de Arequipa, sin que ese público sea
                representativo de las comunidades impactadas”.
              </p>
              <p>
                Más aún, señala, la participación de las comunidades{" "}
                <strong>
                  es un simulacro porque no se toma en cuenta la opinión sobre
                  observaciones al monitoreo. Tampoco se acogen las quejas sobre
                  impactos acústicos (ruidos), polvos en las casas etc.
                </strong>
              </p>
              <p>
                “Estos procesos de MAP, no han logrado crear confianza en las
                relaciones de los pobladores y la mina, y tampoco disminuir las
                tensiones crecientes. Solo se ha logrado ´aplazar´ el problema
                de la conflictividad”, concluye.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto13}
                  alt="Luz Guerra"
                />
                <div className="img-legend">
                  Luz Guerra, dispuesta a pelear hasta el final. Foto: Donofré
                  Chuco/ Servindi
                </div>
              </div>

              <p>
                Luz Guerra, puede dar fe de ello y seguirá, como lo presagia su
                nombre, dando batalla por más claridad en el proceso.
              </p>
            </Fade>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotaArequipa;
